<template>
    <div class="workboard-status" @click="goToReferrals">
        <div class="info-tip">
            <common-icon :name="icon" :size="iconSize"></common-icon>
            <div v-if="(hint || $slots.hint) && !isTabletSmall" class="info-tip__bulb">
                <div class="info-tip__content">
                    <slot>{{ hint }}</slot>
                </div>
            </div>
        </div>

        <div class="workboard-status__number">
            {{ numberOfReferrals }}

            <div v-if="!!numberOfReferrals" class="workboard-status__red-dot"></div>
        </div>

        <div class="workboard-status__title">
            <p>{{ title }}</p>
            <div>
                <span class="workboard-status__subtitle">{{ subtitle }}</span>
                <common-icon
                    v-if="numberOfReferrals"
                    class="workboard-status__icon"
                    name="arrow-right-blue"
                    size="extra-small"
                ></common-icon>
            </div>
        </div>
        <div></div>
    </div>
</template>

<script>
    import ScreenSizeDetectionMixin from 'mixins/ScreenSizeDetectionMixin'

    export default {
        mixins: [ScreenSizeDetectionMixin],

        props: {
            numberOfReferrals: { type: Number, required: false, default: undefined },
            icon: { type: String, required: true },
            iconSize: { type: String, required: true },
            title: { type: String, required: true },
            subtitle: { type: String, required: true },
            hint: { type: String, default: '' },
        },
        methods: {
            goToReferrals() {
                if (this.numberOfReferrals) {
                    this.emitEvent({ name: 'go-to-referrals' })
                }
            },
        },
    }
</script>
